import { useDashboardDataTableState } from './useDashboardDataTableState';

export const DASHBOARD_DATA_TABLE_CLIENT_PAGE_SIZES = [25, 50, 100] as const;

/**
 * Pages a list that is already in memory (e.g. an editor's selected items), so a long list
 * renders one page of rows instead of all of them. Lists that fit on one page get no paging
 * controls. Spread the result into `DashboardDataTable`: `items` and `pagination`.
 */
export function useDashboardDataTableClientPage<TItem>(
  items: readonly TItem[],
  pageSizes: readonly number[] = DASHBOARD_DATA_TABLE_CLIENT_PAGE_SIZES,
) {
  const initialPageSize = pageSizes[0] ?? 25;
  const state = useDashboardDataTableState({
    initialPageSize,
    totalItems: items.length,
    pageSizes,
  });
  if (items.length <= initialPageSize) {
    return { items: [...items], pagination: undefined };
  }
  const start = state.page * state.pageSize;
  return {
    items: items.slice(start, start + state.pageSize),
    pagination: state.pagination,
  };
}
